import { ComponentPropsWithRef } from "react";

export const FunnelIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 0C1.86111 2.39815 6.48148 8.33333 6.48148 8.33333V14.8148H10.1852V8.33333C10.1852 8.33333 14.7963 2.39815 16.6667 0H0Z"
      fill="currentColor"
    />
  </svg>
);
